"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3774,5664],{

/***/ "./src/components/Layout/Footer/Footer.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/media-query/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/index.esm.js + 1 modules
var menu_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/menu/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/chakra-ui-utils.esm.js
var chakra_ui_utils_esm = __webpack_require__("./node_modules/@chakra-ui/utils/dist/chakra-ui-utils.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/data/SocialsData.ts

const Socials = [
    {
        id: 1,
        href: "https://twitter.com/IQWIKI",
        name: "twitter",
        icon: ri_index_esm/* RiTwitterFill */.x2F
    },
    {
        id: 2,
        href: "https://www.reddit.com/r/Everipedia/",
        name: "reddit",
        icon: ri_index_esm/* RiRedditFill */.LWC
    },
    {
        id: 3,
        href: "https://t.me/everipedia",
        name: "telegram",
        icon: ri_index_esm/* RiTelegramFill */.jll
    },
    {
        id: 4,
        href: "https://www.instagram.com/iqwiki_/",
        name: "instagram",
        icon: ri_index_esm/* RiInstagramFill */.Nrw
    },
    {
        id: 5,
        href: "https://github.com/EveripediaNetwork",
        name: "github",
        icon: ri_index_esm/* RiGithubFill */.q7V
    },
    {
        id: 6,
        href: "https://discord.gg/x9EWvTcPXt",
        name: "discord",
        icon: ri_index_esm/* RiDiscordFill */.c63
    },
    {
        id: 7,
        href: "https://web.facebook.com/everipedia?_rdc=1&_rdr",
        name: "facebook",
        icon: ri_index_esm/* RiFacebookFill */.NqZ
    }
];

;// CONCATENATED MODULE: ./src/components/Layout/Footer/SocialFooter.tsx





const SocialFooter = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
        align: {
            base: "center",
            lg: "flex-start"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* SimpleGrid */.MI, {
            mt: 4,
            columns: {
                base: 5,
                md: 7
            },
            children: Socials.map((social)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* SocialIcon */.QZ, {
                    link: social.href,
                    Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        as: social.icon,
                        w: 6,
                        h: 7
                    })
                }, social.href))
        })
    });
};
/* harmony default export */ var Footer_SocialFooter = (SocialFooter);

;// CONCATENATED MODULE: ./src/components/Layout/Footer/MenuFooter.tsx






const MenuFooter = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
        columns: {
            base: 1,
            lg: 12
        },
        py: 10,
        spacing: 12,
        display: {
            base: "initial",
            md: "grid"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                mb: {
                    base: 6,
                    md: 0
                },
                colSpan: {
                    base: 8,
                    lg: 5
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                    align: {
                        base: "center",
                        lg: "flex-start"
                    },
                    spacing: "1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Logo */.TR, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            fontSize: "xl",
                            fontWeight: "bold",
                            children: "".concat(t("everipedia"))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                            w: "80%",
                            align: {
                                base: "center",
                                lg: "start"
                            },
                            fontWeight: "medium",
                            px: {
                                base: 0,
                                lg: 0
                            },
                            pb: {
                                base: "6",
                                md: "0"
                            },
                            children: [
                                "IQ.wiki's vision is to bring blockchain knowledge to the world and knowledge onto the blockchain. A part of",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                    href: "https://www.brainfund.com/",
                                    opacity: "0.8",
                                    _hover: {
                                        opacity: "1",
                                        textDecoration: "underline"
                                    },
                                    target: "_blank",
                                    children: "Brainfund"
                                }),
                                " ",
                                "Group."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_SocialFooter, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                colSpan: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
                    columns: {
                        base: 1,
                        sm: 2,
                        md: 4
                    },
                    spacing: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                            colSpan: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                                align: {
                                    base: "center",
                                    md: "flex-start"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                        size: "sm",
                                        children: "".concat(t("iq"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        target: "_blank",
                                        href: "https://iq.wiki/wiki/iq",
                                        children: "".concat(t("whatIQ"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
                                        direction: "row",
                                        align: "center",
                                        spacing: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                            textAlign: {
                                                base: "center",
                                                md: "left"
                                            },
                                            target: "_blank",
                                            href: "https://learn.everipedia.org/iq/iq/bridges",
                                            children: "".concat(t("bridges"))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        target: "_blank",
                                        href: "https://iq.braindao.org/dashboard/stake",
                                        children: "".concat(t("staking"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        target: "_blank",
                                        href: "https://app.bondprotocol.finance/#/market/1/80",
                                        children: "".concat(t("bonds"))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                            colSpan: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                                align: {
                                    base: "center",
                                    md: "flex-start"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                        size: "sm",
                                        children: "IQ.wiki"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/about",
                                        children: "".concat(t("aboutUs"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                        as: "span",
                                        display: "flex",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                            textAlign: {
                                                base: "center",
                                                md: "left"
                                            },
                                            prefetch: false,
                                            href: "/careers",
                                            children: "".concat(t("careers"))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/branding",
                                        children: "".concat(t("Branding"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        target: "_blank",
                                        href: "https://iq.braindao.org",
                                        children: "IQ Dashboard"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                            colSpan: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                                align: {
                                    base: "center",
                                    md: "flex-start"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                        size: "sm",
                                        children: "".concat(t("resources"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        target: "_blank",
                                        href: "https://learn.everipedia.org/iq/",
                                        children: "".concat(t("help"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/blog",
                                        children: "".concat(t("blog"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/faq",
                                        children: "".concat(t("faq"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/glossary",
                                        children: "".concat(t("glossary"))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                            colSpan: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                                align: {
                                    base: "center",
                                    md: "flex-start"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                        size: "sm",
                                        children: "".concat(t("policies"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/guidelines",
                                        children: "".concat(t("guideLines"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/privacy",
                                        children: "".concat(t("privacyPolicy"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/terms",
                                        children: "".concat(t("termsOfService"))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        prefetch: false,
                                        href: "/CaPrivacyRights",
                                        children: "".concat(t("privacyRights"))
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Footer_MenuFooter = (MenuFooter);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__("./src/utils/googleAnalytics.ts");
;// CONCATENATED MODULE: ./src/components/Layout/Footer/Newsletter.tsx




const Newsletter = (param)=>{
    let { header , body , url , buttonTitle , ...rest } = param;
    const buttonHandler = ()=>{
        (0,googleAnalytics/* logEvent */.K)({
            action: "SUBSCRIBE_BUTTON",
            label: buttonTitle,
            category: "newsletter",
            value: 1
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
        align: {
            base: "center",
            lg: "flex-start"
        },
        spacing: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontSize: "xl",
                fontWeight: "bold",
                py: 2,
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                align: {
                    base: "center",
                    lg: "start"
                },
                maxW: "600px",
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                as: "a",
                href: url,
                target: "_blank",
                size: "lg",
                variant: "solid",
                ...rest,
                onClick: buttonHandler,
                children: buttonTitle
            })
        ]
    });
};
/* harmony default export */ var Footer_Newsletter = (Newsletter);

;// CONCATENATED MODULE: ./src/components/Layout/Footer/index.ts




// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
;// CONCATENATED MODULE: ./src/data/LanguageData.ts
const languageData = [
    {
        id: 1,
        language: "English, US",
        value: "en"
    },
    {
        id: 2,
        language: "Korean",
        value: "ko"
    },
    {
        id: 3,
        language: "Chinese",
        value: "zh"
    }
];

// EXTERNAL MODULE: ./src/components/Elements/LinkElements/Link.tsx
var Link = __webpack_require__("./src/components/Elements/LinkElements/Link.tsx");
;// CONCATENATED MODULE: ./src/components/Layout/Footer/Footer.tsx











const Footer = ()=>{
    const { t , i18n  } = (0,useTranslation/* useTranslation */.$)();
    const spacing = (0,index_esm/* useBreakpointValue */.Sx)({
        base: 8,
        lg: 24
    });
    const [lang, setLang] = (0,react.useState)(languageData[0].value);
    const thisYear = new Date().getFullYear();
    const newsletterOptions = {
        bg: "#fff",
        color: "gray.800",
        _hover: {
            bg: "#fff",
            color: "gray.800"
        }
    };
    const handleLangChange = (userLang)=>{
        if ((0,chakra_ui_utils_esm/* isString */.HD)(userLang)) {
            setLang(userLang);
            i18n.changeLanguage(userLang);
            (0,googleAnalytics/* logEvent */.K)({
                action: "CHANGE_PLATFORM_LANGUAGE",
                category: "language",
                label: userLang,
                value: 1
            });
        }
    };
    const storedLang =  true && JSON.stringify(window.localStorage.storeLang);
    (0,react.useEffect)(()=>{
        if (storedLang) setLang(storedLang);
    }, [
        storedLang
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        bg: "brandBackground",
        color: "default",
        pos: "relative",
        zIndex: "2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Container */.W2, {
            as: dist_index_esm/* Stack */.Kq,
            maxW: {
                base: "7xl",
                xl: "7xl",
                "2xl": "80%"
            },
            py: 5,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
                    columns: {
                        base: 1,
                        lg: 2
                    },
                    spacing: spacing,
                    py: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                            mr: {
                                lg: 24
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Newsletter, {
                                buttonTitle: "Join Now",
                                header: "".concat(t("updatesFooterHeading")),
                                body: "".concat(t("updatesFooterText")),
                                url: "https://forms.gle/bmMce4r3JJckpSNJ7"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Newsletter, {
                                buttonTitle: "Subscribe",
                                header: "Subscribe to our newsletter",
                                body: "Never miss any of the most popular and trending articles on IQ.Wiki when you sign up to our email newsletter.",
                                url: "https://www.getdrip.com/forms/505929689/submissions/new",
                                ...newsletterOptions
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                    orientation: "horizontal"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_MenuFooter, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                    orientation: "horizontal"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
                    fontSize: "sm",
                    columns: {
                        base: 1,
                        lg: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
                            align: {
                                base: "center",
                                lg: "flex-start"
                            },
                            flex: "1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                                alignItems: "center",
                                direction: {
                                    base: "column",
                                    md: "initial"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                    py: 3,
                                    pr: 2,
                                    children: [
                                        " ",
                                        "\xa9 ",
                                        thisYear,
                                        " ",
                                        "".concat(t("copyRight")),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            target: "_blank",
                                            href: "https://braindao.org/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                as: "span",
                                                _hover: {
                                                    textDecoration: "underline"
                                                },
                                                children: "BrainDAO"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                            as: "span",
                                            px: "1",
                                            children: [
                                                "&",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            target: "_blank",
                                            href: "https://iq.braindao.org/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                as: "span",
                                                _hover: {
                                                    textDecoration: "underline"
                                                },
                                                children: [
                                                    "IQ",
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
                            mt: [
                                4,
                                0
                            ],
                            align: {
                                base: "center",
                                lg: "flex-end"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                py: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        cursor: "pointer",
                                        fontSize: 25,
                                        fontWeight: 600,
                                        as: ri_index_esm/* RiGlobalLine */.Vbt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* Menu */.v2, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_dist_index_esm/* MenuButton */.j2, {
                                                    fontSize: "sm",
                                                    children: [
                                                        lang.toUpperCase(),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {})
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuList */.qy, {
                                                    color: "linkColor",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuOptionGroup */.__, {
                                                        type: "radio",
                                                        onChange: handleLangChange,
                                                        children: languageData.map((langObj)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(menu_dist_index_esm/* MenuItemOption */.ii, {
                                                                fontSize: "md",
                                                                value: langObj.value,
                                                                children: langObj.language
                                                            }, langObj.id))
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_Footer = (Footer);


/***/ })

}]);